import { Condition } from "@redotech/redo-model/return-flow/condition";
import {
  fulfillmentTrackingUpdateWithinFromModel,
  validateFulfillmentTrackingUpdateWithinCondition,
  type FulfillmentTrackingUpdateWithinState,
} from "@redotech/redo-model/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const FULFILLMENT_TRACKING_UPDATE_WITHIN = (
  Details: React.ComponentType<
    ConditionTypeDetailsProps<FulfillmentTrackingUpdateWithinState>
  >,
): ConditionType<
  FulfillmentTrackingUpdateWithinState,
  Condition.FulfillmentTrackingUpdateWithin
> => ({
  name: "Time since last tracking update",
  description(numDays) {
    return `Within ${numDays} days of last tracking update`;
  },
  Details(
    props: ConditionTypeDetailsProps<FulfillmentTrackingUpdateWithinState>,
  ) {
    return React.createElement(Details, props);
  },
  empty: (30).toFixed(0),
  fromModel(model) {
    return fulfillmentTrackingUpdateWithinFromModel(model);
  },
  toModel(state) {
    return {
      type: Condition.FULFILLMENT_TRACKING_UPDATE_WITHIN,
      duration: Temporal.Duration.from({ days: +state }),
    };
  },
  valid(state) {
    return validateFulfillmentTrackingUpdateWithinCondition(state).valid;
  },
});

export { type FulfillmentTrackingUpdateWithinState } from "@redotech/redo-model/return-flow/condition-validate";
